import React from 'react';
import {
  Box,
  Button,
  Typography,
  Paper,
  Grid,
  Stack,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import NavigationBar from '../components/NavigationBar';
import CollapsibleSidebar from '../components/CollapsibleSidebar';

import DashboardIcon from '@mui/icons-material/Dashboard';
import { GrRobot, GrCompare } from 'react-icons/gr';
import SearchIcon from '@mui/icons-material/Search';
import { handleLogout } from '../utils/auth';

function HomePage() {
  const navigate = useNavigate();
  const userName = '';
  const userEmail = '';

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh' }}>
      <CollapsibleSidebar />

      <Box sx={{ flexGrow: 1 }}>
        <NavigationBar
          userName={userName}
          userEmail={userEmail}
          onLogout={handleLogout}
        />

        <Box
          sx={{
            padding: 4,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '90vh',
            backgroundColor: '#f5f5f5',
          }}
        >
          <Paper
            elevation={3}
            sx={{
              padding: 6,
              width: '100%',
              maxWidth: 600,
              borderRadius: '25px',
              textAlign: 'center',
              backgroundColor: 'white',
            }}
          >
            <Typography variant="h4" gutterBottom sx={{ fontWeight: 'bold' }}>
              Welcome to Success Suite
            </Typography>

            <Typography variant="subtitle1" sx={{ mb: 4, color: 'text.secondary' }}>
              Select a tool to get started:
            </Typography>

            <Stack spacing={2}>
              <Button
                fullWidth
                variant="contained"
                startIcon={<DashboardIcon />}
                onClick={() => navigate('/batch_ask?mode=knowledge')}
              >
                Batch Ask Knowledge
              </Button>

              <Button
                fullWidth
                variant="contained"
                startIcon={<GrRobot style={{ fontSize: 18 }} />}
                onClick={() => navigate('/batch_ask?mode=gpt')}
              >
                Batch Ask ChatGPT
              </Button>

              <Button
                fullWidth
                variant="contained"
                startIcon={<GrCompare style={{ fontSize: 18 }} />}
                onClick={() => navigate('/answer_comparison')}
              >
                Answer Comparison
              </Button>

              <Button
                fullWidth
                variant="outlined"
                startIcon={<SearchIcon />}
                disabled
                sx={{ opacity: 0.5 }}
              >
                Vector DB Search (Coming Soon)
              </Button>
            </Stack>
          </Paper>
        </Box>
      </Box>
    </Box>
  );
}

export default HomePage;